export default{
  SET_TOKEN(state,dt=''){
    state.TOKEN = dt;
  },
  SET_REFRESH_TOKEN(state,dt=''){
    state.REFRESH_TOKEN = dt;
  },
  SET_ACCESS_TOKEN(state,dt=''){
    state.ACCESS_TOKEN = dt;
  },
  SET_USER_INFO(state,dt={}){
    state.INFO = dt||'';
  },
  CLEAR_USER_INFO(state){
    state.INFO = '';
    state.TOKEN = '';
    state.REFRESH_TOKEN = '';
    state.ACCESS_TOKEN = '';
  }
  
}


// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js